import { createApiSlice } from "@common";
import { CRUD_SOURCE } from "@routes";

const apiConfig = [
  {
    name: "addSource",
    method: "post",
    url: CRUD_SOURCE,
    stateKey: "message",
  },
  {
    name: "getSource",
    method: "get",
    url: CRUD_SOURCE,
    stateKey: "data",
  },
  {
    name: "updateSource",
    method: "put",
    url: CRUD_SOURCE,
    stateKey: "message",
  },
  {
    name: "deleteSource",
    method: "delete",
    url: CRUD_SOURCE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "source",
  apiConfig,
  customReducers);
const sourceSlice = slice;

export default sourceSlice.reducer;

export const {
  addSource,
  getSource,
  updateSource,
  deleteSource,
} = thunks;

export const { rowSelect } = actions;
